import { Link } from 'react-router-dom';
import { Sparkles, Award, Heart, ArrowRight } from 'lucide-react';
import { Reveal } from '@/components/Reveal';
import { IMAGES } from '@/lib/data';

const AboutPage = () => {
  return (
    <div className="pt-28">
      {/* HERO */}
      <section className="relative py-24 sm:py-32">
        <div className="luxe-container grid lg:grid-cols-12 gap-16 items-center">
          <div className="lg:col-span-6">
            <Reveal>
              <div className="luxe-eyebrow mb-4">About Lavish Luxe</div>
              <h1 className="text-4xl sm:text-6xl text-white leading-[1.05]">
                Luxury care for vehicles that deserve <span className="italic text-[#C9A24A]">more</span> than a basic wash.
              </h1>
              <div className="gold-divider mt-8" />
              <p className="mt-8 text-white/60 leading-relaxed max-w-xl">
                Lavish Luxe Detailing was built on precision, pride, and a
                passion for automotive excellence. Every vehicle is treated
                with high-end care — restoring beauty, shine, and protection
                that lasts.
              </p>
            </Reveal>
          </div>
          <Reveal className="lg:col-span-6" delay={150}>
            <div className="relative">
              <div className="absolute -top-6 -right-6 w-40 h-40 border border-[#C9A24A]/40" />
              <img
                src={IMAGES.premiumWash}
                alt="Premium wash"
                className="relative w-full h-[520px] object-cover"
              />
            </div>
          </Reveal>
        </div>
      </section>

      {/* STORY */}
      <section className="py-24 border-y border-white/5 bg-[#0d1220]">
        <div className="luxe-container max-w-4xl mx-auto text-center">
          <Reveal>
            <div className="luxe-eyebrow mb-4">Our Story</div>
            <h2 className="text-3xl sm:text-5xl text-white leading-tight">
              Born in <span className="italic text-[#C9A24A]">St. Louis</span>,<br />
              built on obsession.
            </h2>
            <div className="gold-divider mx-auto mt-8" />
            <p className="mt-8 text-white/70 leading-relaxed text-lg font-light">
              What started as a personal love for immaculate cars has grown
              into St. Louis' go-to detailing studio. We believe that a clean
              car is a form of luxury — a daily ritual of pride, protection,
              and presence. Every appointment is treated as an invitation into
              your world, and we bring the studio to you.
            </p>
          </Reveal>
        </div>
      </section>

      {/* VALUES */}
      <section className="py-24 sm:py-32">
        <div className="luxe-container">
          <Reveal>
            <div className="text-center max-w-2xl mx-auto mb-16">
              <div className="luxe-eyebrow mb-4">What We Stand For</div>
              <h2 className="text-3xl sm:text-5xl text-white">
                Three <span className="italic text-[#C9A24A]">principles</span>. One standard.
              </h2>
            </div>
          </Reveal>

          <div className="grid md:grid-cols-3 gap-6">
            {[
              {
                icon: Sparkles,
                title: 'Precision Detailing',
                desc: 'Every panel, seam, and stitch — inspected, cleaned, and finished with intention.',
              },
              {
                icon: Award,
                title: 'Premium Products',
                desc: 'We use only pro-grade chemistry, ceramic sealants, and microfibre tools.',
              },
              {
                icon: Heart,
                title: 'Customer Satisfaction',
                desc: 'Your car returns to you feeling brand new — or we make it right.',
              },
            ].map((v, i) => {
              const Icon = v.icon;
              return (
                <Reveal key={v.title} delay={i * 120}>
                  <div className="luxe-card p-10 h-full text-center">
                    <Icon size={36} className="text-[#C9A24A] mx-auto mb-6" />
                    <h3 className="text-2xl text-white mb-4">{v.title}</h3>
                    <p className="text-white/60 leading-relaxed text-sm">
                      {v.desc}
                    </p>
                  </div>
                </Reveal>
              );
            })}
          </div>

          <div className="text-center mt-16">
            <Link to="/booking" data-testid="about-book-cta" className="btn-gold">
              Experience Lavish Luxe <ArrowRight size={14} />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;
